var _defs, _rect, _rect2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-111{fill:#caccd0;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 2.11,
    y: 5.06,
    width: 1.5,
    height: 12.77
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 7.82,
    y: 5.06,
    width: 1.5,
    height: 12.77
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "15.43 4.99 21.89 11.45 15.43 17.91 14.37 16.85 19.77 11.45 14.37 6.05 15.43 4.99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandNavIcon);
export default __webpack_public_path__ + "static/media/expand_nav_icon.688a5335a3bc380db247189993d3c050.svg";
export { ForwardRef as ReactComponent };